import _classCallCheck from "/opt/noser/hris/uat1/producthris/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/noser/hris/uat1/producthris/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/noser/hris/uat1/producthris/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/noser/hris/uat1/producthris/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "/opt/noser/hris/uat1/producthris/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/opt/noser/hris/uat1/producthris/node_modules/@babel/runtime/helpers/esm/inherits";
import _toConsumableArray from "/opt/noser/hris/uat1/producthris/node_modules/@babel/runtime/helpers/esm/toConsumableArray";

/**
 * DevExtreme (esm/renovation/ui/pager/pages/large.js)
 * Version: 21.1.12
 * Build date: Fri Apr 07 2023
 *
 * Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["pageIndexes"],
    _excluded2 = ["defaultPageIndex", "maxPagesCount", "pageCount", "pageIndex", "pageIndexChange"];
import { createVNode, createFragment, createComponentVNode } from "inferno";
import { Fragment } from "inferno";
import { BaseInfernoComponent } from "@devextreme/vdom";
import { Page } from "./page";
import { PagerProps } from "../common/pager_props";
import { ConfigContext } from "../../../common/config_context";
var PAGER_PAGE_SEPARATOR_CLASS = "dx-separator";
export var viewFunction = function viewFunction(_ref) {
  var pages = _ref.pages;
  var PagesMarkup = pages.map(function (_ref2) {
    var key = _ref2.key,
        pageProps = _ref2.pageProps;
    return pageProps ? createComponentVNode(2, Page, {
      index: pageProps.index,
      selected: pageProps.selected,
      onClick: pageProps.onClick
    }, key) : createVNode(1, "div", PAGER_PAGE_SEPARATOR_CLASS, ". . .", 16, null, key);
  });
  return createFragment(PagesMarkup, 0);
};
var PAGES_LIMITER = 4;

function getDelimiterType(startIndex, slidingWindowSize, pageCount) {
  if (1 === startIndex) {
    return "high";
  }

  if (startIndex + slidingWindowSize === pageCount - 1) {
    return "low";
  }

  return "both";
}

function createPageIndexesBySlidingWindowIndexes(slidingWindowIndexes, pageCount, delimiter) {
  var pageIndexes = [];
  var indexesForReuse = [];

  switch (delimiter) {
    case "none":
      pageIndexes = _toConsumableArray(slidingWindowIndexes);
      break;

    case "both":
      pageIndexes = [0, "low"].concat(_toConsumableArray(slidingWindowIndexes), ["high", pageCount - 1]);
      indexesForReuse = slidingWindowIndexes.slice(1, -1);
      break;

    case "high":
      pageIndexes = [0].concat(_toConsumableArray(slidingWindowIndexes), ["high", pageCount - 1]);
      indexesForReuse = slidingWindowIndexes.slice(0, -1);
      break;

    case "low":
      pageIndexes = [0, "low"].concat(_toConsumableArray(slidingWindowIndexes), [pageCount - 1]);
      indexesForReuse = slidingWindowIndexes.slice(1);
  }

  return {
    slidingWindowIndexes: slidingWindowIndexes,
    indexesForReuse: indexesForReuse,
    pageIndexes: pageIndexes
  };
}

function createPageIndexes(startIndex, slidingWindowSize, pageCount, delimiter) {
  var slidingWindowIndexes = [];

  for (var i = 0; i < slidingWindowSize; i += 1) {
    slidingWindowIndexes.push(i + startIndex);
  }

  return createPageIndexesBySlidingWindowIndexes(slidingWindowIndexes, pageCount, delimiter);
}

var PagesLargePropsType = {
  maxPagesCount: PagerProps.maxPagesCount,
  pageCount: PagerProps.pageCount,
  defaultPageIndex: PagerProps.pageIndex
};
export var PagesLarge =
/*#__PURE__*/
function (_BaseInfernoComponent) {
  _inherits(PagesLarge, _BaseInfernoComponent);

  function PagesLarge(props) {
    var _this;

    _classCallCheck(this, PagesLarge);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PagesLarge).call(this, props));
    _this._currentState = null;
    _this.state = {
      pageIndex: void 0 !== _this.props.pageIndex ? _this.props.pageIndex : _this.props.defaultPageIndex
    };
    _this.canReuseSlidingWindow = _this.canReuseSlidingWindow.bind(_assertThisInitialized(_this));
    _this.generatePageIndexes = _this.generatePageIndexes.bind(_assertThisInitialized(_this));
    _this.isSlidingWindowMode = _this.isSlidingWindowMode.bind(_assertThisInitialized(_this));
    _this.onPageClick = _this.onPageClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(PagesLarge, [{
    key: "set_pageIndex",
    value: function set_pageIndex(value) {
      var _this2 = this;

      this.setState(function (state) {
        var _this$props$pageIndex, _this$props;

        _this2._currentState = state;
        var newValue = value();
        null === (_this$props$pageIndex = (_this$props = _this2.props).pageIndexChange) || void 0 === _this$props$pageIndex ? void 0 : _this$props$pageIndex.call(_this$props, newValue);
        _this2._currentState = null;
        return {
          pageIndex: newValue
        };
      });
    }
  }, {
    key: "canReuseSlidingWindow",
    value: function canReuseSlidingWindow(currentPageCount, pageIndex) {
      var indexesForReuse = this.slidingWindowState.indexesForReuse;
      var lastIndexForReuse = indexesForReuse[indexesForReuse.length - 1];
      var lastPageIsFartherThanWindow = lastIndexForReuse < currentPageCount - 1;
      var pageIndexExistInIndexes = -1 !== indexesForReuse.indexOf(pageIndex);
      return lastPageIsFartherThanWindow && pageIndexExistInIndexes;
    }
  }, {
    key: "generatePageIndexes",
    value: function generatePageIndexes() {
      var pageCount = this.props.pageCount;
      var startIndex = 0;
      var slidingWindowIndexes = this.slidingWindowState.slidingWindowIndexes;

      if (this.__state_pageIndex === slidingWindowIndexes[0]) {
        startIndex = this.__state_pageIndex - 1;
      } else if (this.__state_pageIndex === slidingWindowIndexes[slidingWindowIndexes.length - 1]) {
        startIndex = this.__state_pageIndex + 2 - PAGES_LIMITER;
      } else if (this.__state_pageIndex < PAGES_LIMITER) {
        startIndex = 1;
      } else if (this.__state_pageIndex >= pageCount - PAGES_LIMITER) {
        startIndex = pageCount - PAGES_LIMITER - 1;
      } else {
        startIndex = this.__state_pageIndex - 1;
      }

      var slidingWindowSize = PAGES_LIMITER;
      var delimiter = getDelimiterType(startIndex, slidingWindowSize, pageCount);

      var _createPageIndexes = createPageIndexes(startIndex, slidingWindowSize, pageCount, delimiter),
          pageIndexes = _createPageIndexes.pageIndexes,
          slidingWindowState = _objectWithoutPropertiesLoose(_createPageIndexes, _excluded);

      this.slidingWindowStateHolder = slidingWindowState;
      return pageIndexes;
    }
  }, {
    key: "isSlidingWindowMode",
    value: function isSlidingWindowMode() {
      var _this$props3 = this.props,
          maxPagesCount = _this$props3.maxPagesCount,
          pageCount = _this$props3.pageCount;
      return pageCount <= PAGES_LIMITER || pageCount <= maxPagesCount;
    }
  }, {
    key: "onPageClick",
    value: function onPageClick(pageIndex) {
      var _this$props$pageIndex2, _this$props2;

      null === (_this$props$pageIndex2 = (_this$props2 = this.props).pageIndexChange) || void 0 === _this$props$pageIndex2 ? void 0 : _this$props$pageIndex2.call(_this$props2, pageIndex);
    }
  }, {
    key: "render",
    value: function render() {
      var props = this.props;
      return viewFunction({
        props: _extends({}, props, {
          pageIndex: this.__state_pageIndex
        }),
        config: this.config,
        pageIndexes: this.pageIndexes,
        pages: this.pages,
        restAttributes: this.restAttributes
      });
    }
  }, {
    key: "config",
    get: function get() {
      if ("ConfigContext" in this.context) {
        return this.context.ConfigContext;
      }

      return ConfigContext;
    }
  }, {
    key: "__state_pageIndex",
    get: function get() {
      var state = this._currentState || this.state;
      return void 0 !== this.props.pageIndex ? this.props.pageIndex : state.pageIndex;
    }
  }, {
    key: "slidingWindowState",
    get: function get() {
      var slidingWindowState = this.slidingWindowStateHolder;

      if (!slidingWindowState) {
        return {
          indexesForReuse: [],
          slidingWindowIndexes: []
        };
      }

      return slidingWindowState;
    }
  }, {
    key: "pageIndexes",
    get: function get() {
      var pageCount = this.props.pageCount;

      if (this.isSlidingWindowMode()) {
        return createPageIndexes(0, pageCount, pageCount, "none").pageIndexes;
      }

      if (this.canReuseSlidingWindow(pageCount, this.__state_pageIndex)) {
        var slidingWindowIndexes = this.slidingWindowState.slidingWindowIndexes;
        var delimiter = getDelimiterType(slidingWindowIndexes[0], PAGES_LIMITER, pageCount);
        return createPageIndexesBySlidingWindowIndexes(slidingWindowIndexes, pageCount, delimiter).pageIndexes;
      }

      return this.generatePageIndexes();
    }
  }, {
    key: "pages",
    get: function get() {
      var _this3 = this;

      var _this$config;

      var createPage = function createPage(index) {
        var pagerProps = "low" === index || "high" === index ? null : {
          index: index,
          onClick: function onClick() {
            return _this3.onPageClick(index);
          },
          selected: _this3.__state_pageIndex === index
        };
        return {
          key: index.toString(),
          pageProps: pagerProps
        };
      };

      var rtlPageIndexes = null !== (_this$config = this.config) && void 0 !== _this$config && _this$config.rtlEnabled ? _toConsumableArray(this.pageIndexes).reverse() : this.pageIndexes;
      return rtlPageIndexes.map(function (index) {
        return createPage(index);
      });
    }
  }, {
    key: "restAttributes",
    get: function get() {
      var _this$props$pageIndex3 = _extends({}, this.props, {
        pageIndex: this.__state_pageIndex
      }),
          restProps = _objectWithoutPropertiesLoose(_this$props$pageIndex3, _excluded2);

      return restProps;
    }
  }]);

  return PagesLarge;
}(BaseInfernoComponent);
PagesLarge.defaultProps = _extends({}, PagesLargePropsType);